var $$ = $$ || {};

$$.DeliveryPopup = class DeliveryPopup {
    constructor (root) {
        this.root = root;

        this._cacheNodes();
        this._bindEvents();
    }

    _cacheNodes () {
        this.nodes = {
            title: this.root.find('.js-popup-title'),
            content: this.root.find('.js-popup-content')
        };
    }
    
    _bindEvents () {
        $$.body.on('mouseup', (event) => {
            if (!this.root.has(event.target).length) {
                this.nodes.content.css('display', 'none');
            }
        });

        this.nodes.title.on('click', (event) => {
            this._showOrHidePopup();
        });
    }

    _showOrHidePopup () {
        if (this.nodes.content.css('display') === 'none') {
            this.nodes.content.css('display', 'block')
        } else {
            this.nodes.content.css('display', 'none');
        }
    }
};

